<div class="card-body">
    <div id="apex-stacked-columns-100"></div>
</div>